(() => {
  'use strict';
  function enhanceFAQ(entry) {
    if (entry.dataset.hlxFaqEnhanced === 'true') return;
    const headings = [...entry.children].filter(node => node.tagName === 'H2');
    if (!headings.length) return;
    entry.dataset.hlxFaqEnhanced = 'true';
    headings.forEach(heading => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const answer = document.createElement('div');
      details.className = 'hlx-content-faq-item';
      answer.className = 'hlx-content-faq-answer';
      while (heading.firstChild) summary.appendChild(heading.firstChild);
      details.appendChild(summary);
      details.appendChild(answer);
      entry.insertBefore(details, heading);
      entry.removeChild(heading);
      let next = details.nextSibling;
      while (next && next.nodeName !== 'H2') {
        const node = next;
        next = next.nextSibling;
        answer.appendChild(node);
      }
    });
  }
  function mount(scope = document) {
    scope.querySelectorAll('.hlx-content-help .entry-content').forEach(enhanceFAQ);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { enhanceFAQ };
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount()); else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
